import { eDanhSachNganh2ActionsObj } from "../../action-types/quan-ly-nganh-2/IDanhSachNganh2Actions";
import { generateActions } from "../generateActions";

export const danhSachNganh2Actions = {
    ...generateActions(eDanhSachNganh2ActionsObj, "DANH_SACH_NGANH_2"),
}